var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.383 14.385q-.666-1.356-2.185-1.794t-3.14-.437q-1.612 0-3.155.437q-1.544.438-2.17 1.794zm-5.325-3.231q.842 0 1.856.153t1.94.522t1.633.99t.941 1.583q.095.373-.151.678t-.636.305H3.474q-.39 0-.636-.305q-.247-.305-.152-.678q.236-.961.945-1.583t1.634-.99q.926-.37 1.938-.522q1.011-.153 1.854-.153m-6.116 7.538q-.212 0-.356-.144q-.144-.143-.144-.356t.144-.356t.356-.144h12.231q.213 0 .356.144t.144.357t-.144.356t-.356.143zM18.99 22h-.816q-.212 0-.356-.144t-.144-.357t.144-.356t.356-.143h.9l1.4-13.615H11.95q-.212 0-.356-.144t-.144-.357t.144-.356t.356-.143h3.992v-3.5q0-.213.144-.357t.357-.144t.356.144t.143.356v3.5h3.727q.364 0 .61.263q.248.263.198.626l-1.415 13.816q-.056.413-.358.662t-.716.249m-1.315-1h1.4zm-14.73 1q-.213 0-.357-.144t-.144-.357t.144-.356t.356-.143h12.231q.212 0 .356.144t.144.357t-.144.356t-.356.143zm6.115-7.616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDining);
export default __webpack_public_path__ + "static/media/dining.fc216ec5e489c20ac6c758ef464fd742.svg";
export { ForwardRef as ReactComponent };